//ye sab svg icon list hai
import Elements from "./Elements";
import Text from "./Text";
import Templates from "./Templates";
import Customize from "./Customize";
import Activity from "./Activity";
import AddFolder from "./AddFolder"
import Folder from "./Folder"
import Video from "./Video";
import Photo from "./Photo"
import Analytics from "./Analytics"
import Images from "./Images";
import Graphics from "./Graphics";
import Pixabay from "./Pixabay";
import Uploads from "./Uploads";
import Layers from "./Layers";
import Redo from "./Redo";
import Undo from "./Undo";
import Refresh from "./Refresh";
import Add from "./Add";
import Bold from "./Bold";
import Italic from "./Italic";
import Delivery from "./Delivery";
import Mobile from "./Mobile";
import Ipad from "./Ipad";
import Desktop from "./Desktop";
import NewTap from "./NewTap";
import TextColor from "./TextColor";

import Music from "./Music"
import Style from "./Style";
import Setting from "./Setting";
import LinkMediaC from "../PropertyList/LinkMedia";
import LinkmediamainC from "../PropertyList/Linkmediamain";
import VideosC from "../PropertyList/Videos";
import PhotosC from "../PropertyList/Photos";
import AnalyticsC from "../PropertyList/Analytics";
import HeadingC from "../PropertyList/Heading";
import BackgroundC from "../PropertyList/Background";
import MusicC from "../PropertyList/Music";
import StylesC from "../PropertyList/Styles";
import SettingsC from "../PropertyList/Settings";
import DeliverC from "../PropertyList/Deliver";
import AccountsettingC from "../PropertyList/Accountsetting";
import CompanysettingC from "../PropertyList/CompanySetting";
import DomainsettingC from "../PropertyList/DomainSetting";
import PlanbillC from "../PropertyList/Planbill";
import CreditusageC from "../PropertyList/Creditusage";
 
 

 

//Ye niche wale main property list hai jab hum kisi object ko select krte hai to ye use object ki property show krta hai 
// for example support I click on recording square button which is on canvas then it will trigger RecordingP which has component of <Position canvas={canvas} /> where we set postion of recording object
import ImagesP from "../PropertyList/Images";
 
 

 
   
import NewFolderCreateP from "../PropertyList/NewFolderCreateP";
import NewGalleryCreateP from "../PropertyList/NewGalleryCreateP";
import VideoPlayerP from "../PropertyList/VideoPlayerP";
import RenameCreateP from "../PropertyList/RenameCreateP";
 
 
 
 
 
 


//ye sabhi modal hai jo as a popup open hote 
import NewFolderModal from "../modal/NewFolderModal";
import NewGalleryModal from "../modal/NewGalleryModal";
import VideoPlayerModal from "../modal/VideoPlayerModal";
import NewTemplateModal from "../modal/NewTemplateModal";
import AddMediaModal from "../modal/AddMediaModal";
import RenameModal from "../modal/RenameModal";
import VideoAdvanceSetting from "../PropertyList/VideoAdvanceSetting";
import VideoGeneralSetting from "../PropertyList/VideoGeneralSetting";

class Icons {
  static Elements = Elements;
  static Text = Text;
  static Templates = Templates;
  //static Search = Search
  static Images = Images;
  // static Videos = Video
  static Graphics = Graphics;
  static Pixabay = Pixabay;
  static Uploads = Uploads;
  static Customize = Customize;
  static Activity = Activity;
  static Layers = Layers;

  static Folder = Folder;
  static AddFolder = AddFolder;
  static Video = Video;
  static Photo = Photo;
  static Music = Music;
  static Analytics = Analytics
 static Style = Style;
 static Setting= Setting;
 
  static NewFolderCreateP = NewFolderCreateP;
  static NewGalleryCreateP = NewGalleryCreateP;
  static VideoPlayerP = VideoPlayerP;
  static RenameCreateP = RenameCreateP;

 static VideoAdvanceSetting = VideoAdvanceSetting;
 static VideoGeneralSetting = VideoGeneralSetting;
 
 
  static ImagesP = ImagesP;
 
 
  static LinkMediaC = LinkMediaC;
  static LinkmediamainC = LinkmediamainC;
  static VideosC = VideosC;
  static PhotosC = PhotosC;
    static AnalyticsC = AnalyticsC;
  static HeadingC = HeadingC;


 

static BackgroundC = BackgroundC;
static MusicC = MusicC;
static StylesC = StylesC;
static SettingsC = SettingsC;
static DeliverC = DeliverC;



static AccountsettingC = AccountsettingC;
static CompanysettingC = CompanysettingC;
static DomainsettingC = DomainsettingC;
static PlanbillC = PlanbillC;
static CreditusageC = CreditusageC;
 
  static NewFolderModal = NewFolderModal;
  static NewGalleryModal = NewGalleryModal;
  static NewTemplateModal = NewTemplateModal;
  static VideoPlayerModal = VideoPlayerModal;
  static RenameModal = RenameModal;
  static AddMediaModal = AddMediaModal;
 
  
 

  /*canvas footer Nav item*/
  static Redo = Redo;
  static Refresh = Refresh;
  static Undo = Undo;
  static Add = Add;

  /*canvas Header Nav item*/
  static Bold = Bold;
  static Italic = Italic;
 static Delivery = Delivery;
  static TextColor = TextColor;
 
 
/*NEW ICON*/
static NewTap = NewTap;
static Mobile = Mobile;
static Ipad = Ipad;
static Desktop = Desktop;
 
 
}

export default Icons;
